import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import WardValidation from "../../../../hooks/WardValidation";
import { occupyBed } from "../../../../store/actions/bedsAction";
import Popup from "../../../common/modal/Popup";
import redBox from "../../../../assets/images/red.png";
import yellowBox from "../../../../assets/images/yellow.png";
import greenBox from "../../../../assets/images/greenBox.png";
import Loader from "../../../common/loader/Loader";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";

const EditOccupied = (props) => {
  const { selectBed } = props;
  const { wardId } = useParams();
  const [isShow, setIsShow] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [edate, setEDate] = useState(null);
  const [adate, setADate] = useState(null);
  const [bedDetail, setBedDetail] = useState({
    patientInitials:null,
    nhsNumber: null,
    dateOfAdmission: null,
    currentEDD: null,
    comment: null,
    socialCareNeed: null,
    category: null,
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    WardValidation({
      nhsNumber: bedDetail?.nhsNumber ? bedDetail?.nhsNumber : null,
      dateOfAdmission: bedDetail?.dateOfAdmission
        ? bedDetail?.dateOfAdmission
        : null,
      currentEDD: bedDetail?.currentEDD ? bedDetail?.currentEDD : null,
      socialCareNeed: bedDetail?.socialCareNeed
        ? bedDetail?.socialCareNeed
        : null,
      category: bedDetail?.category ? bedDetail?.category : null,
    });

  const dispatch = useDispatch();
  const {
    isRecordUpdated,
    error: apiError,
    isLoader,
  } = useSelector((state) => state.beds);

  useEffect(() => {
    console.log("seytting bedDetail 97", selectBed);
    setBedDetail({
      bedId: selectBed?._id,
      patientInitials:selectBed?.patientInitials,
      nhsNumber: selectBed?.nhsNumber,
      dateOfAdmission: moment(selectBed?.dateOfAdmission).format("YYYY-MM-DD"),
      currentEDD: moment(selectBed?.currentEDD).format("YYYY-MM-DD"),
      socialCareNeed: selectBed?.socialCareNeed,
      category: selectBed?.category,
      comment: selectBed?.comment,
    });
  }, [selectBed]);

  const submitHandler = async (e) => {
    console.log("action called");
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      let formData = {
        wardId: wardId,
        bedId: bedDetail?.bedId,
        patientInitials:bedDetail?.patientInitials,
        nhsNumber: bedDetail?.nhsNumber,
        dateOfAdmission: bedDetail?.dateOfAdmission,
        currentEDD: bedDetail?.currentEDD,
        socialCareNeed: bedDetail?.socialCareNeed,
        category: bedDetail?.category,
        comment: bedDetail?.comment,
      };
      console.log("formdata", formData);
      console.log("error", error);
      if (!isError() && error !== null && isActionCalled) {
        dispatch(occupyBed(formData)).then(({ payload }) => {
          if (payload.success) {
            hideHandler();
            setADate(null);
            setEDate(null);
          } else {
            setIsShow(true);
          }
        });
        setIsActionCalled(false);
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  useEffect(() => {
    console.log("bedDetail 97", bedDetail);
    if (bedDetail?.dateOfAdmission) {
      setADate(new Date(bedDetail?.dateOfAdmission));
    }
  }, [bedDetail?.dateOfAdmission]);

  useEffect(() => {
    console.log("bedDetail 105", bedDetail);
    if (bedDetail?.currentEDD) {
      setEDate(new Date(bedDetail?.currentEDD));
    }
  }, [bedDetail?.currentEDD]);

  const hideHandler = () => {
    console.log("bedDetail hideHandler", bedDetail);
    resetAllValidator();
    props.onHide();

    setADate(null);
    setEDate(null);
    setBedDetail({
      bedId: selectBed?._id,
      patientInitials:null,
      nhsNumber: selectBed?.nhsNumber,
      dateOfAdmission: moment(selectBed?.dateOfAdmission).format("YYYY-MM-DD"),
      currentEDD: moment(selectBed?.currentEDD).format("YYYY-MM-DD"),
      socialCareNeed: selectBed?.socialCareNeed,
      category: selectBed?.category,
      comment: null,
    });
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const { onHide, ...props1 } = props;
  return (
    <>
      <Popup
        {...props1}
        onHide={hideHandler}
        size="md"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectBed ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        
        <Form.Group className="mb-3">
          <Form.Label>Enter NHS Number</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter NHS number"
            autoFocus
            name="nhsNumber"
            value={bedDetail && bedDetail.nhsNumber}
            maxlength="10"
            onChange={(e) => {
              setBedDetail({
                ...bedDetail,
                nhsNumber: e.target.value,
              });
              resetValidator(e.target.name);
            }}
            isInvalid={error && error?.nhsNumber}
          />
          <Form.Control.Feedback type="invalid">
            {error && error?.nhsNumber}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Patient Initials</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter patient intials"
            
            name="patientInitials"
            value={bedDetail && bedDetail.patientInitials}
            onChange={(e) => {
              setBedDetail({
                ...bedDetail,
                patientInitials: e.target.value,
              });
            }}
            maxLength={30}
          />
        </Form.Group>
        <Form.Group className="mb-3 ">
          <Form.Label>Date of admission</Form.Label>
          <Form.Control
            className="py-2 date-box"
            type="date"
            placeholder="Select"
            column={6}
            name="dateOfAdmission"
            value={bedDetail && bedDetail?.dateOfAdmission}
            max={
              bedDetail?.dateOfAdmission
                ? bedDetail?.dateOfAdmission
                : edate && edate?.getFullYear()
                ? edate?.getFullYear() +
                  "-" +
                  ("0" + (edate?.getMonth() + 1).toString()).substr(-2) +
                  "-" +
                  ("0" + edate?.getDate()).substr(-2)
                : moment().format("YYYY-MM-DD")
            }
            onChange={(e) => {
              setBedDetail({
                ...bedDetail,
                dateOfAdmission: e.target.value,
              });
              resetValidator(e.target.name);
            }}
            isInvalid={error && error?.dateOfAdmission}
          />
          <Form.Control.Feedback type="invalid">
            {error && error?.dateOfAdmission}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 ">
          <Form.Label>Estimated Date Of Discharge</Form.Label>
          <Form.Control
            disabled
            className="py-2 date-box"
            type="date"
            placeholder="Select"
            column={6}
            name="currentEDD"
            value={bedDetail && bedDetail?.currentEDD}
            min={
              bedDetail?.dateOfAdmission
                ? bedDetail?.dateOfAdmission
                : adate && adate?.getFullYear()
                ? adate?.getFullYear() +
                  "-" +
                  ("0" + (adate?.getMonth() + 1).toString()).substr(-2) +
                  "-" +
                  ("0" + adate?.getDate()).substr(-2)
                : ""
            }
            onChange={(e) => {
              setBedDetail({
                ...bedDetail,
                currentEDD: e.target.value,
              });
              resetValidator(e.target.name);
            }}
            isInvalid={error && error?.currentEDD}
          />
          <Form.Control.Feedback type="invalid">
            {error && error?.currentEDD}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Category</Form.Label>

          <div className="d-flex ">
            <Form.Check
              name="category"
              checked={bedDetail && bedDetail?.category === "Step Up"}
              // value={bedDetail && bedDetail?.category}
              value="Step Up"
              onClick={(e) => {
                console.log("clicked up");
                setBedDetail({
                  ...bedDetail,
                  category: e.target.value,
                });
                resetValidator("category");
              }}
              className="me-4"
              type="radio"
              label="Step Up"
            />
            <Form.Check
              name="category"
              checked={bedDetail && bedDetail?.category === "Step Down"}
              // value={bedDetail && bedDetail?.category}
              value="Step Down"
              onClick={(e) => {
                console.log("clicked down");
                setBedDetail({
                  ...bedDetail,
                  category: e.target.value,
                });
                resetValidator("category");
              }}
              type="radio"
              label="Step Down"
            />
          </div>

          {error && error?.category && (
            <p className="textDanger">Please select category</p>
          )}
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Dependency Score</Form.Label>

          <div className="d-flex justify-content-between">
            <span
              onClick={(e) => {
                console.log("clicked red");
                setBedDetail({
                  ...bedDetail,
                  socialCareNeed: "HIGH",
                });
                resetValidator("socialCareNeed");
              }}
              className="d-flex colorBox colorBox-high"
              style={{
                backgroundColor:
                  bedDetail?.socialCareNeed == "HIGH" ? "#EE473F" : "",
                color: bedDetail?.socialCareNeed == "HIGH" ? "white" : "",
              }}
            >
              <img src={redBox} />
              High
            </span>
            <span
              onClick={(e) => {
                console.log("clicked yellow");
                setBedDetail({
                  ...bedDetail,
                  socialCareNeed: "MODERATE",
                });
                resetValidator("socialCareNeed");
              }}
              className="d-flex colorBox colorBox-mid"
              style={{
                backgroundColor:
                  bedDetail?.socialCareNeed == "MODERATE" ? "#F8A80C" : "",
                color: bedDetail?.socialCareNeed == "MODERATE" ? "white" : "",
              }}
            >
              <img src={yellowBox} />
              Moderate
            </span>
            <span
              onClick={(e) => {
                console.log("clicked green");
                setBedDetail({
                  ...bedDetail,
                  socialCareNeed: "LOW",
                });
                resetValidator("socialCareNeed");
              }}
              className="d-flex colorBox colorBox-low"
              style={{
                backgroundColor:
                  bedDetail?.socialCareNeed == "LOW" ? "#15BA9B" : "",
                color: bedDetail?.socialCareNeed == "LOW" ? "white" : "",
              }}
            >
              <img src={greenBox} />
              Low
            </span>
          </div>

          {error && error?.socialCareNeed && (
            <p className="textDanger">please select dependency score</p>
          )}
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Type Here"
            name="comment"
            value={bedDetail && bedDetail?.comment}
            onChange={(e) => {
              setBedDetail({
                ...bedDetail,
                comment: e.target.value,
              });
              resetValidator(e.target.name);
            }}
            isInvalid={error && error?.comment}
          />
          <Form.Control.Feedback type="invalid">
            {error && error?.comment}
          </Form.Control.Feedback>
        </Form.Group>

        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded: isShow,
            title: selectBed ? "Update Occupy" : "Add Occupy",
            successMsg: "",
            errorRes: apiError?.message,
          }}
        />
      </Popup>
    </>
  );
};

export default EditOccupied;
